import {courseById} from 'constants/url';
import authFetch from '../../../helpers/requests';
import {useSelector} from 'react-redux';

function useLoadCourseById(id: number) {
  const loadCourse = useLoad(courseById, id);
  return () => loadCourse();
}
function useLoad(url: string, id: number) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return () =>
    authFetch(`${url}?id=${id}`, {mode: 'cors'}, token)
      .then((response: any) => response.text())
      .then((data) => (data ? JSON.parse(data) : {}))
      .catch((e) => {
        return {};
      });
}
export default useLoadCourseById;
